import mutations from './mutations';
import actions from './actions';

export const getInitialState = () => ({
  soundPlaying: true,
  soundMuted: false,
  soundStopped: false,
  soundVolume: 1.0,
  showCaption: false,
  captionSize: 18,
  captionSizePercentage: 100,
  animationsOn: true,
  onGoingAnimation: null,
  currentTweenIndex: 1,
  currentKeyboardingSegment: '',
  totalKeyboardingSegment: ''
});

export default {
  namespaced: true,
  state: getInitialState(),
  mutations,
  actions
};
